import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import ChangePassword from './Pages/ChangePassword';
import { isAuthenticated, mustChangePassword } from './Services/AuthService';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    // O destino original vai junto: um link de aviso (`/?catalogo=<id>`) sobrevive ao login.
    if (!isAuthenticated()) return <Navigate to="/login" replace state={{ from: location }} />;
    // Quem ainda deve trocar a senha inicial não passa daqui: o token dele é recusado no resto do backoffice.
    if (mustChangePassword()) return <Navigate to="/trocar-senha" replace />;
    return children;
};

const SessionRoute = ({ children }) => (isAuthenticated() ? children : <Navigate to="/login" replace />);

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                    path="/trocar-senha"
                    element={
                        <SessionRoute>
                            <ChangePassword />
                        </SessionRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
